import { useCallback, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Refresh as RetryIcon } from '@mui/icons-material';

import { getAutomarkerTargetTemplates } from '@dyl/apiClients/backendApi';
import createDatabaseManager from '@dyl/utils/createDatabaseManager';
import createSnackbarAction from '@dyl/utils/createSnackbarAction';

const { Provider: AmttManager, use: useRaw } = createDatabaseManager({
    requestHook: function useAmttRequest() {
        const { enqueueSnackbar } = useSnackbar();

        return useCallback(async () => {
            while (true) {
                try {
                    return await getAutomarkerTargetTemplates();
                }
                catch {
                    await new Promise(resolve => enqueueSnackbar(
                        'Failed to load automarker targets', {
                            variant: 'error',
                            persist: true,
                            action: createSnackbarAction({
                                iconComponent: RetryIcon,
                                onClick: resolve,
                            }),
                        }
                    ));
                }
            }
        }, []);
    },
    defaultValue: [],
    contextName: 'AmttManager',
});

export default AmttManager;

export function useAutomarkerTargetTemplates() {
    const {
        data: templates,
        status: templatesStatus,
        refresh: refreshTemplates,
    } = useRaw();

    useEffect(() => {
        if (templatesStatus !== 'complete') {
            refreshTemplates();
        }
    }, []);

    return {
        templates,
        templatesStatus,
        refreshTemplates,
    };
}